import React from "react";
import { Link } from "react-router-dom";

function Articles() {

  return (

    <main className="homepage articles-page public-section-landing">

      <h1 style={{ textAlign: "center" }}>
        Articles
      </h1>

      <p
        style={{
          textAlign: "center",
          color: "#666",
          marginBottom: "40px",
          fontSize: "18px"
        }}
      >
        Browse articles by category.
      </p>

      <div className="article-category-grid">

        <Link
          to="/articles/international"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  🌍
</div>
<h2>International</h2>
        <p>International affairs and global developments.</p>
        </Link>

        <Link
          to="/articles/national"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  🇮🇳
</div>
<h2>National</h2>
          <p>National issues and current affairs.</p>
        </Link>

        <Link
          to="/articles/state"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  🏛️
</div>
<h2>State</h2>
          <p>State affairs and regional developments.</p>
        </Link>

        <Link
          to="/articles/sports"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  🏆
</div>
<h2>Sports</h2>
          <p>Sports news, analysis and commentary.</p>
        </Link>

        <Link
          to="/articles/science"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  🔬
</div>
<h2>Science & Technology</h2>
          <p>Science, technology, innovation and research.</p>
        </Link>

        <Link
  to="/articles/ink-and-echo"
  className="publication-card"
>
  <div className="landing-category-icon" aria-hidden="true">
    ✒️
  </div>
  <h2>Ink &amp; Echo</h2>
  <p>
    Stories, poems, literature and cultural expression.
  </p>
</Link>

        <Link
          to="/articles/environment"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  🌱
</div>
<h2>Environment</h2>
          <p>
            Environment, ecology, climate and conservation.
          </p>
        </Link>

        <Link
          to="/articles/her-space"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  ♀️
</div>
<h2>Her Space</h2>
          <p>
            Women’s voices, rights, experiences and achievements.
          </p>
        </Link>

        <Link
          to="/articles/tribal-voices"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  🗣️
</div>
<h2>Tribal Voices</h2>
          <p>
            Indigenous communities, culture and issues.
          </p>
        </Link>

      </div>

    </main>

  );

}

export default Articles;